import { Card, Col } from "antd";
import { useGetInsightQuery } from "../../slices/strategyApiSlice";

const InsightsCard = ({ strategyId }) => {

const { data: insight } = useGetInsightQuery(strategyId, {
  skip: !strategyId,
});

// console.log(insight);

  return (
    <Col md={24} xs={24}>
      <Card title="💡 Insights">
        <div style={{ lineHeight: "32px" }}>
          <div style={{ color: "#2ecc71" }}>
            ● Highest win rate on {insight?.highestWinDay} ({insight?.winRate}%)
          </div>

          <div style={{ color: "#3498db" }}>
            ● {insight?.lossAfter3Win} losses after 3 consecutive wins
          </div>

          <div style={{ color: "#f1c40f" }}>
            ● Best performance between {insight?.bestTime}
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default InsightsCard;